(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(63543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


const SeoHead = (props)=>{
    const { seo  } = props;
    const { canonicalUrl  } = seo;
    const twitter = seo.socials.find((social)=>social.network === "twitter");
    const facebook = seo.socials.find((social)=>social.network === "facebook");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            facebook && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: facebook.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: facebook.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: seo.canonicalUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(facebook.image.data.attributes.url)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Codealo"
                    })
                ]
            }),
            twitter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitter.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: twitter.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(twitter.image.data.attributes.url)
                    })
                ]
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: seo.robots
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 60699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56438);
/* harmony import */ var _organisms_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35604);
/* harmony import */ var _organisms_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58620);





const DefaultLayout = (param)=>{
    let { seo , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_SeoHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex min-h-screen flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        className: "flex-1",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 89415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98683);
/* harmony import */ var react_syntax_highlighter_dist_cjs_styles_prism_darcula__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24560);





class CodeBlock extends react__WEBPACK_IMPORTED_MODULE_1__.PureComponent {
    render() {
        const { language , value  } = this.props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            language: language,
            style: react_syntax_highlighter_dist_cjs_styles_prism_darcula__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            children: value
        });
    }
}
CodeBlock.propTypes = {
    value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    language: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
CodeBlock.defaultProps = {
    language: null
};
/* harmony default export */ __webpack_exports__["Z"] = (CodeBlock);


/***/ }),

/***/ 44139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74740);
/* harmony import */ var _CodeBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89415);





const Markdown = (param)=>{
    let { content , width , id  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .ReactMarkdown */ .D, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("prose mx-auto scroll-mt-20", {
                "max-w-prose": width === "prose",
                "max-w-full": width === "full"
            }),
            linkTarget: "_blank",
            components: {
                code (param) {
                    let { node , inline , className , children , ...props } = param;
                    const match = /language-(\w+)/.exec(className || "");
                    return !inline && match ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CodeBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        value: String(children).replace(/\n$/, ""),
                        language: match[1],
                        ...props
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "after: rounded-sm bg-gray-200 px-1 font-mono text-solid-red before:text-red-950 after:text-red-950"),
                        ...props,
                        children: children
                    });
                }
            },
            children: content
        })
    });
};
Markdown.defaultProps = {
    width: "prose",
    id: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (Markdown);


/***/ }),

/***/ 50680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function Index() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "h-screen min-h-full bg-white px-6 py-16 sm:py-24 md:grid md:place-items-center lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: "sm:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-4xl font-bold tracking-tight text-primary sm:text-5xl",
                            children: "404"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sm:ml-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:border-l sm:border-gray-200 sm:pl-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                            children: "P\xe1gina no se encontro"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-2 text-base text-gray-500",
                                            children: "Revisa la URL e intenta de nuevo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/",
                                        className: "hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent bg-primary px-4 py-2 font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2",
                                        children: "Regresar a casa \uD83C\uDFE1"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}


/***/ }),

/***/ 63543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(60699);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/molecules/Markdown/index.tsx
var Markdown = __webpack_require__(44139);
;// CONCATENATED MODULE: ./src/components/views/Blog/BlogPost.tsx




const BlogPost = (param)=>{
    let { post  } = param;
    const { attributes  } = post;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative overflow-hidden py-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:absolute lg:inset-y-0 lg:block lg:h-full lg:w-full lg:[overflow-anchor:none]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mx-auto h-full max-w-prose text-lg",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "absolute left-full top-12 translate-x-32 transform",
                                width: 404,
                                height: 384,
                                fill: "none",
                                viewBox: "0 0 404 384",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                            id: "74b3fd99-0a6f-4271-bef2-e80eeafdf357",
                                            x: 0,
                                            y: 0,
                                            width: 20,
                                            height: 20,
                                            patternUnits: "userSpaceOnUse",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                x: 0,
                                                y: 0,
                                                width: 4,
                                                height: 4,
                                                className: "text-gray-200",
                                                fill: "currentColor"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                        width: 404,
                                        height: 384,
                                        fill: "url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "absolute right-full top-1/2 -translate-x-32 -translate-y-1/2 transform",
                                width: 404,
                                height: 384,
                                fill: "none",
                                viewBox: "0 0 404 384",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                            id: "f210dbf6-a58d-4871-961e-36d5016a0f49",
                                            x: 0,
                                            y: 0,
                                            width: 20,
                                            height: 20,
                                            patternUnits: "userSpaceOnUse",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                x: 0,
                                                y: 0,
                                                width: 4,
                                                height: 4,
                                                className: "text-gray-200",
                                                fill: "currentColor"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                        width: 404,
                                        height: 384,
                                        fill: "url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "absolute bottom-12 left-full translate-x-32 transform",
                                width: 404,
                                height: 384,
                                fill: "none",
                                viewBox: "0 0 404 384",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                                            id: "d3eb07ae-5182-43e6-857d-35c643af9034",
                                            x: 0,
                                            y: 0,
                                            width: 20,
                                            height: 20,
                                            patternUnits: "userSpaceOnUse",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                x: 0,
                                                y: 0,
                                                width: 4,
                                                height: 4,
                                                className: "text-gray-200",
                                                fill: "currentColor"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                        width: 404,
                                        height: 384,
                                        fill: "url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative px-2 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto max-w-prose lg:text-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mb-6 mt-2 block text-center text-2xl font-bold leading-8 tracking-tight text-primary sm:text-3xl",
                                    children: attributes.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                            content: attributes.body,
                            width: "prose"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Blog_BlogPost = (BlogPost);

// EXTERNAL MODULE: ./src/pages/404.tsx
var _404 = __webpack_require__(50680);
;// CONCATENATED MODULE: ./src/pages/blog/[slug].tsx




const Index = (param)=>{
    let { post  } = param;
    if (!post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
        seo: post.attributes.seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_BlogPost, {
            post: post
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2552,9842,1687,9746,9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);